/* LoadingStatusIndicator.tsx generated by @compiled/babel-plugin v3.0.2 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useIntl } from 'react-intl';
import StatusDiscoveryIcon from '@atlaskit/icon/core/status-discovery';
import StatusErrorIcon from '@atlaskit/icon/core/status-error';
import StatusInfoIcon from '@atlaskit/icon/core/status-information';
import StatusSuccessIcon from '@atlaskit/icon/core/status-success';
import StatusWarningIcon from '@atlaskit/icon/core/status-warning';
import TaskToDo from '@atlaskit/icon/core/task-to-do';
import Spinner from '@atlaskit/spinner/spinner';
import messages from './messages';
export type LoadingStatus = 'loading' | 'success' | 'error' | 'info' | 'warning' | 'discovery' | 'to-do';
export const StatusIndicator = ({
  status,
  testId,
  size = 'medium'
}: {
  status: LoadingStatus;
  testId?: string;
  size?: 'small' | 'medium';
}): JSX.Element | undefined => {
  const {
    formatMessage
  } = useIntl();
  switch (status) {
    case 'loading':
      return <Spinner size="small" label={formatMessage(messages.loading)} testId={testId} />;
    case 'success':
      return <StatusSuccessIcon label={formatMessage(messages.success)} size={size} color={"var(--ds-icon-success, #6A9A23)"} testId={testId} />;
    case 'info':
      return <StatusInfoIcon label={formatMessage(messages.info)} size={size} color={"var(--ds-text-information, #1558BC)"} testId={testId} />;
    case 'error':
      return <StatusErrorIcon label={formatMessage(messages.error)} size={size} color={"var(--ds-text-danger, #AE2E24)"} testId={testId} />;
    case 'warning':
      return <StatusWarningIcon label={formatMessage(messages.warning)} size={size} color={"var(--ds-icon-warning, #E06C00)"} testId={testId} />;
    case 'discovery':
      return <StatusDiscoveryIcon label={formatMessage(messages.discovery)} size={size} color={"var(--ds-icon-discovery, #AF59E1)"} testId={testId} />;
    case 'to-do':
      return <TaskToDo label={formatMessage(messages.todo)} size={size} testId={testId} />;
    // explicitly return nothing from default case.
    // This shouldn't happen since `status` is required, but it could if someone casts incorrectly or data is undefined from the server.
    default:
  }
};